module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/kv_results-5f4dbf5d54daf99d5cb0537f1dbfdb57.png";